import type { SocialLinkData } from '@beat-venues/common-types';
import { type VariantProps, cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';

import { getIconName } from '../../utils/icon-util';
import { getIconComponent, ButtonOrLink, Text } from '../../';

export interface SocialListProps
    extends CommonProps,
        VariantProps<typeof SocialListStyles> {
    socialLinks: SocialLinkData[];
}

export const SocialListStyles = cva('flex justify-center xs:justify-end gap-4');

export const SocialList = ({
    socialLinks,
    className,
    testId = 'social-list',
    ...props
}: SocialListProps): JSX.Element => {
    return (
        <ul
            className={twMerge(SocialListStyles({ className }))}
            data-testid={testId}
            {...props}
        >
            {socialLinks.map((socialLink, id) => (
                <li key={id}>
                    <ButtonOrLink
                        className="hover:text-brand-500"
                        href={socialLink.href}
                        testId="social-list-link"
                    >
                        <Text className="sr-only">{socialLink.id}</Text>
                        {getIconComponent(getIconName(socialLink.id), {
                            size: 'lg',
                        })}
                    </ButtonOrLink>
                </li>
            ))}
        </ul>
    );
};
